import { c as _c } from "react/compiler-runtime";
import { useProducers } from '@newfront-insurance/admin-ui/accounts';
import { DetailCard, EmployeeAvatar, Flexbox, SingleObjectSelector, Text, useFuzzy } from '@newfront-insurance/core-ui';
import { isSuccesfulResult } from '@newfront-insurance/data-layer-http';
import type { JSX } from 'react';
import { useSelectedProducer } from '@/client/providers/selected-producer-provider';
export function ProducerSelector() {
  const $ = _c(14);
  const {
    currentProducer,
    setCurrentProducer,
    removeCurrentProducer
  } = useSelectedProducer();
  const {
    data: producers,
    isLoading
  } = useProducers();
  let t0;
  if ($[0] !== producers) {
    t0 = isSuccesfulResult(producers) && producers ? producers : [];
    $[0] = producers;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const employees = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keys: ["name", "title", "email"],
      debounce: 300
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    results,
    search
  } = useFuzzy(employees, t1);
  let t2;
  if ($[3] !== results) {
    t2 = results.slice(0, 20);
    $[3] = results;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = currentProducer ?? null;
  let t4;
  if ($[5] !== removeCurrentProducer || $[6] !== setCurrentProducer) {
    t4 = employee_2 => {
      if (employee_2) {
        setCurrentProducer(employee_2.userUuid);
      } else {
        removeCurrentProducer();
      }
    };
    $[5] = removeCurrentProducer;
    $[6] = setCurrentProducer;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isLoading || $[9] !== search || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <SingleObjectSelector items={t2} selectedItem={t3} renderItem={_temp} isLoading={isLoading} getItemKey={_temp2} itemToString={_temp3} onSelect={t4} renderSelectedItem={_temp4} emptyPlaceholder="View accounts as producer..." onSearch={search} />;
    $[8] = isLoading;
    $[9] = search;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp4(employee_3) {
  return <Flexbox gap={8}><EmployeeAvatar sizeInPixels={24} imageUrl={employee_3.imageUrl} initials={employee_3.name} /><Text weight={600}>{employee_3.name}</Text></Flexbox>;
}
function _temp3(employee_1) {
  return employee_1?.name ?? "";
}
function _temp2(employee_0) {
  return employee_0.uuid;
}
function _temp(employee, t0) {
  const {
    isHovering,
    isSelected
  } = t0;
  return <DetailCard isHovering={isHovering} isHighlighted={isSelected} title={employee.name} subtitle={employee.title} cardProps={{
    hasRadius: false,
    hideBorder: true
  }} />;
}